// extracted by mini-css-extract-plugin
export default {"component":"LandStakingBottom_component__lVIKO","stats":"LandStakingBottom_stats__CYJFM"};